@if (!hideToolbarActions) {
    <div class="betslip-picks-toolbar__selection">
        <ds-checkbox
            size="medium"
            popperApplyClass="tooltip-msg,tooltip-msg--first"
            [checked]="allPicksSelected"
            [popper]="messages.selectAllTooltip"
            [popperTrigger]="NgxPopperjsTriggers.hover"
            [popperPlacement]="NgxPopperjsPlacements.TOPSTART"
            [popperPreventOverflow]="true"
            (checkedChange)="togglePicksSelection($event)" />
    </div>
}

<div class="betslip-picks-toolbar__spacer"></div>
@if (!hideToolbarActions) {
    <div class="betslip-picks-toolbar__settings">
        <i
            class="theme-settings-i"
            popperApplyClass="tooltip-msg"
            *msShowInEpcot="{ showInEpcot: false, module: module }"
            [popper]="messages.bettingOptionsTooltip"
            [popperTrigger]="NgxPopperjsTriggers.hover"
            [popperPlacement]="NgxPopperjsPlacements.TOP"
            [popperPreventOverflow]="false"
            (click)="openSettingsDialog()">
        </i>
        <i
            class="theme-settings"
            popperApplyClass="tooltip-msg"
            *msShowInEpcot="{ showInEpcot: true, module: module }"
            [popper]="messages.bettingOptionsTooltip"
            [popperTrigger]="NgxPopperjsTriggers.hover"
            [popperPlacement]="NgxPopperjsPlacements.TOP"
            [popperPreventOverflow]="false"
            (click)="openSettingsDialog()">
        </i>
    </div>
}

@if (!hideToolbarActions) {
    <span
        class="betslip-picks-toolbar__remove-all"
        [ngClass]="{ 'betslip-picks-toolbar__remove-all--confirm': confirmRemoveAll, 'betslip-picks-toolbar__remove-all-request': !confirmRemoveAll }"
        (click)="requestRemoveAllPicks()">
        @if (!confirmRemoveAll) {
            <div>
                <span
                    class="theme-bin"
                    popperApplyClass="tooltip-msg"
                    *msShowInEpcot="{ showInEpcot: false, module: module }"
                    [popper]="messages.deleteAllTooltip"
                    [popperTrigger]="NgxPopperjsTriggers.hover"
                    [popperPlacement]="NgxPopperjsPlacements.TOPEND"></span>
                <span
                    class="theme-recycle-bin"
                    popperApplyClass="tooltip-msg"
                    *msShowInEpcot="{ showInEpcot: true, module: module }"
                    [popper]="messages.deleteAllTooltip"
                    [popperTrigger]="NgxPopperjsTriggers.hover"
                    [popperPlacement]="NgxPopperjsPlacements.TOPEND"></span>
            </div>
        } @else {
            <span class="theme-recycle-bin"></span>
        }
        @if (confirmRemoveAll) {
            <span>{{ messages.removeAllMessage }}</span>
        }
    </span>
}
